/** Stub for embed bundle: @vue-util/forms/mask-util */
export function phoneFormat(value) {
  return value == null ? '' : String(value);
}
export function currencyFormat(value) {
  return value == null ? '' : String(value);
}
